import React from "react";
import Reveal from "../components/Reveal";
import CtaSection from "../components/CtaSection";
import { BRAND } from "../lib/brand";
import { useSeo, orgLd, breadcrumbLd } from "../lib/seo";

export default function About() {
  useSeo({
    title: "About Aesthetiq",
    description: "Aesthetiq makes objective facial-aesthetics analysis accessible to everyone — on the open web, with a real plan to improve.",
    path: "/about",
    jsonLd: [orgLd, breadcrumbLd([{ name: "Home", path: "/" }, { name: "About", path: "/about" }])],
  });

  return (
    <div>
      <section className="container max-w-3xl py-16">
        <Reveal>
          <span className="label-eyebrow">About</span>
          <h1 className="mt-3 font-display text-5xl sm:text-6xl">Self-improvement deserves real data.</h1>
          <div className="mt-8 space-y-5 text-lg text-muted-foreground">
            <p>{BRAND.name} started with a simple frustration: the best face-analysis tools were locked inside iPhone-only apps with weekly subscriptions, opaque single-number scores, and no way to actually share or track your progress.</p>
            <p>We rebuilt the experience for the open web. Upload a photo from any device and get an objective, repeatable analysis across eight facial metrics — plus an AI Coach plan that tells you exactly what to work on, and a Future-Face projection that shows what's realistically achievable.</p>
            <p>Our philosophy is simple: a score is only useful if it comes with a plan and a way to measure progress. Everything we build is constructive, body-positive and grounded in measurable proportions — never a verdict on your worth.</p>
          </div>
          <div className="mt-10 grid grid-cols-3 gap-4">
            {[["128k+", "Faces analysed"], ["8", "Metrics per scan"], ["1,000+", "Data points / scan"]].map(([n, l]) => (
              <div key={l} className="rounded-xl border border-border bg-card p-5 text-center">
                <p className="font-display text-3xl text-primary">{n}</p>
                <p className="mt-1 text-xs text-muted-foreground">{l}</p>
              </div>
            ))}
          </div>
        </Reveal>
      </section>
      <CtaSection />
    </div>
  );
}
